import React from "react";
import styled from "styled-components";
import Pictures from "../../components/Locals";

const DivLogo = styled.div` 
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 40px;
  margin-top: 3rem;
  
    img {
      height: 100%;
      width: auto;
  }

  @media screen and (max-width: 500px){
    margin-top: 0rem;
  }

`;

const Logo: React.FC = () => {
  return (
    <DivLogo>
      <img className="logo" src={Pictures["logo"].default} />
    </DivLogo>
  );
};

export default Logo;
